import React, { useEffect } from 'react';
import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import theme from '@/styles/theme';

interface Props {
  isVisible?: boolean;
}

const LoadingPage = (props: Props) => {
  const { isVisible = false } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isVisible]);

  return (
    <Wrapper isVisible={isVisible}>
      <Loader type="ThreeDots" color={theme.DF_COLOR.BLUE600} height={80} width={80} />
    </Wrapper>
  );
};

export default LoadingPage;

const Wrapper = styled.div<{ isVisible: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  ${({ isVisible }) => !isVisible && 'display:none;'}
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${theme.utils.withOpacity(theme.DF_COLOR.GRAY100, 0.5)};
  justify-content: center;
  align-items: center;
  z-index: 1000;
  position: fixed;
`;
